import React, { useState } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";
import { useSelector } from 'react-redux';
import {selectVendorEmailAddress, selectVendorPhoneNumber} from '../../../data/user/selectors';
import { getBrandName } from 'utils/brand';

const NoEligibleLeads = ({ isOpen, onClose, onConfirm }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const vendorPhoneNumber = useSelector(selectVendorPhoneNumber);
    const vendorEmailAddress = useSelector(selectVendorEmailAddress);

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                uniqId="EndCampaign"
                width="auto"
                padding="0"
                modalClassName={css.pricingModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                    <div className={classNames(css.clsModalContent, "modal-content")}>
                        <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                            <div className={css.rbModalTextGroup}>
                                <div className={css.rbModalTitle}>No Eligible Leads Available</div>
                                <div className={css.rbModalDetails}>
                                    <span>Dialer Campaigns require leads with associated property  <br></br> information so relevant details can be displayed during  <br></br>outreach. If you believe this is an error or need assistance,<br></br>please contact {getBrandName()} Customer Support at <br></br> {vendorPhoneNumber} or {vendorEmailAddress}.</span>
                                </div>
                            </div>
                            <div className={css.buttonRemoveWrapper}>
                                <button className={classNames(css.connectBtn, { [css.noClick]: isSubmitting })} onClick={onClose}>
                                    <span className={css.connectRmvBtnLabel}>Ok</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default NoEligibleLeads;